var scope_0 = require('/opt/build/repo/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/22b225e3793a282804211392b7cd5455.js').default;export default
        Object.assign({}, scope_0 )
    